import { useState, useEffect } from 'react';
import { TelegramWebApp } from '../types';

interface TelegramWebAppHook {
  webApp: TelegramWebApp | null;
  isReady: boolean;
  isTelegramEnvironment: boolean;
  user: any | null;
  initData: string | null;
}

export const useTelegramWebApp = (): TelegramWebAppHook => {
  const [webApp, setWebApp] = useState<TelegramWebApp | null>(null);
  const [isReady, setIsReady] = useState(false);
  const [isTelegramEnvironment, setIsTelegramEnvironment] = useState(false);

  useEffect(() => {
    const isMockEnabled = import.meta.env.VITE_ENABLE_TELEGRAM_MOCK === 'true';
    
    // Check if we're running in Telegram WebApp
    if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
      const tgWebApp = window.Telegram.WebApp;
      
      // Проверяем что у нас есть реальные данные от Telegram
      const hasValidInitData = tgWebApp.initData && tgWebApp.initData.trim() !== '';
      const hasValidUser = tgWebApp.initDataUnsafe?.user?.id;
      
      if (hasValidInitData && hasValidUser) {
        setWebApp(tgWebApp);
        setIsTelegramEnvironment(true);
        setIsReady(true);
      } else {
        setIsTelegramEnvironment(false);
        setIsReady(true);
      }
    } else {
      // Проверяем если это development режим
      const isDevelopment = import.meta.env.DEV;
      
      if (isDevelopment && isMockEnabled) {
        // Create a mock WebApp for development
        const mockWebApp: TelegramWebApp = {
          initData: 'query_id=AAHdF6IQAAAAAN0XohDhrOrc&user=%7B%22id%22%3A279058397%2C%22first_name%22%3A%22Test%22%2C%22last_name%22%3A%22User%22%2C%22username%22%3A%22testuser%22%2C%22language_code%22%3A%22ru%22%2C%22is_premium%22%3Afalse%7D&auth_date=' + Math.floor(Date.now() / 1000) + '&hash=mock_hash_for_development',
          initDataUnsafe: {
            query_id: 'AAHdF6IQAAAAAN0XohDhrOrc',
            user: {
              id: 279058397,
              first_name: 'Test',
              last_name: 'User',
              username: 'testuser',
              language_code: 'ru',
              is_premium: false,
            },
            auth_date: Math.floor(Date.now() / 1000),
            hash: 'mock_hash_for_development',
          },
          version: '6.9',
          platform: 'web',
          colorScheme: 'light',
          themeParams: {
            bg_color: '#FFFFFF',
            text_color: '#1e1f26',
            hint_color: '#1e1f26',
            link_color: '#283655',
            button_color: '#4d648d',
            button_text_color: '#ffffff',
            secondary_bg_color: '#d0e1f9',
          },
          isExpanded: true,
          viewportHeight: window.innerHeight,
          viewportStableHeight: window.innerHeight,
          headerColor: '#FFFFFF',
          backgroundColor: '#FFFFFF',
          isClosingConfirmationEnabled: false,
          BackButton: {
            isVisible: false,
            onClick: () => {},
            offClick: () => {},
            show: () => {},
            hide: () => {},
          },
          MainButton: {
            text: 'MAIN BUTTON',
            color: '#4d648d',
            textColor: '#ffffff',
            isVisible: false,
            isProgressVisible: false,
            isActive: true,
            onClick: () => {},
            offClick: () => {},
            setText: () => {},
            show: () => {},
            hide: () => {},
            enable: () => {},
            disable: () => {},
            showProgress: () => {},
            hideProgress: () => {},
          },
          HapticFeedback: {
            impactOccurred: () => {},
            notificationOccurred: () => {},
            selectionChanged: () => {},
          },
          expand: () => {},
          close: () => {},
          ready: () => {},
        };
        
        setWebApp(mockWebApp);
        setIsTelegramEnvironment(true);
        
      } else {
        setIsTelegramEnvironment(false);
      }
      
      setIsReady(true);
    }
  }, []);

  const user = webApp?.initDataUnsafe?.user || null;
  

  return {
    webApp,
    isReady,
    isTelegramEnvironment,
    user,
    initData: webApp?.initData || null,
  };
}; 